import React, { Fragment } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Textlink from '@xingternal/malt-textlink';
import { H, P } from '@xingternal/malt-typography';

import BlacklistedImage from './../../Components/Illustrations/BlacklistedImage';
import messages from './messages';
import styles from './Blacklisted.css';

const buildLink = (href, text) => <Textlink href={href}>{text}</Textlink>;

const Blacklisted = ({ intl }) => (
  <Fragment>
    <BlacklistedImage />
    <H>
      <FormattedMessage {...messages.salutation} />
    </H>
    <P>
      <FormattedMessage {...messages.paragraph1} />
    </P>
    <P>
      <FormattedMessage {...messages.paragraph2} />
    </P>
    <P className={styles.emailLink}>
      {buildLink(
        intl.formatMessage(messages.paragraph2linkTarget),
        intl.formatMessage(messages.paragraph2linkText)
      )}
    </P>
    <P>
      <FormattedMessage
        {...messages.paragraph3}
        values={{
          helpCenterLink: buildLink(
            intl.formatMessage(messages.paragraph3linkTarget),
            intl.formatMessage(messages.paragraph3linkText)
          ),
        }}
      />
    </P>
  </Fragment>
);

Blacklisted.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Blacklisted);
